<form id="memberForm"
        name="memberForm"
        #memForm=ngForm
        (ngSubmit)="onMemberOKClick()">

  <h3 class="modal-header center blue-text">
    {{ isEdit ? ('PROJECT.PROJECT_INFO.MEMBER.TITLE_EDIT' | anessaTranslation) : ('PROJECT.PROJECT_INFO.MEMBER.TITLE_ADD' | anessaTranslation) }}
  </h3>
  <div class="modal-body">
    <mat-form-field>
      <mat-label>{{'PROJECT.PROJECT_INFO.MEMBER.NAME' | anessaTranslation}}</mat-label>
      <input id="member-name_input"
             type="text"
             matInput
             name="memberName"
             required
             [(ngModel)]="member.name"
      >
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'PROJECT.PROJECT_INFO.MEMBER.TITLE' | anessaTranslation}}</mat-label>

      <input
        id="member-title_input"
        matInput
        type="text"
        name="memberTitle"
        [(ngModel)]="member.title"
      >
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'PROJECT.PROJECT_INFO.MEMBER.EMAIL' | anessaTranslation}}</mat-label>
      <input
        id="member-email_input"
        matInput
        email
        required
        type="text"
        name="memberEmail"
        [(ngModel)]="member.email"
      >
    </mat-form-field>

  </div>
  <div class="modal-footer">
    <button id="member-add_button"
            class=" btn-green"
            mat-raised-button
            [disabled]="memForm.invalid"
            type="submit">{{ isEdit ? ('PROJECT.COMMON.SAVE' | anessaTranslation) : ('PROJECT.COMMON.ADD' | anessaTranslation) }}
    </button>
    <button id="member-cancel_button"
            class="btn-red"
            color="warn"
            mat-raised-button=""
            type="button"
            (click)="onCancelClick()"
            anessaTranslation="PROJECT.COMMON.CANCEL">
    </button>
  </div>
</form>
